import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { DistritoSelect } from 'sharedComponents/select'

const IdDistritoFormGroup = ({ idProvincia, iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='DISTRITO' htmlFor='select-idDistrito' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='_idDistrito'>
          {({ field }) => (
            <DistritoSelect {...field} idProvincia={idProvincia} disabled={fIsSubmitting} isInvalid={iTouched && iError} id='select-idDistrito' />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(IdDistritoFormGroup)
